import React from 'react';
import { Modal, Box, TextField, MenuItem, IconButton, CircularProgress, Button } from '@material-ui/core';

// Styling for the modal wrapper and internal sections
const modalWrapperStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '70%',
    maxHeight: '90vh',
    backgroundColor: 'white',
    borderRadius: 12,
    boxShadow: 24,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
};

const headerStyle = {
    backgroundColor: '#75287C',
    color: 'white',
    padding: '0px 24px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    minHeight: 56,
};

const contentStyle = {
    padding: 24,
    flex: 1, // take remaining space
    overflowY: 'auto',
};

const actionsStyle = {
    padding: '16px 24px',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 12,
    borderTop: '1px solid #eee',
};

const FormModalLoanReadiness = ({
    open,
    onClose,
    isPersonaLoading,
    formData,
    handleInputChange,
    uniqueLoandReadinessInstanceId,
    onSubmit, // Add this prop to handle form submit
    isEdit = { isEdit },
    handleUpdateButtonClick,
    submitBusinessLoanPersonaForm,
    loanReadinessAlreadyFilledPersonaInstanceId
}) => {
    return (
        <Modal open={open} onClose={onClose}>
            <Box style={modalWrapperStyle}>

                {/* Header */}
                <Box style={headerStyle}>
                    <div>Loan Readiness Persona Form</div>
                    <IconButton onClick={onClose} style={{ color: 'white' }}>
                        X
                    </IconButton>
                </Box>

                {/* Form content */}
                <Box style={contentStyle} className={`${isPersonaLoading ? "set-opacity" : ""}`}>
                    {isPersonaLoading && (
                        <div className="center-screen">
                            <CircularProgress />
                        </div>
                    )}

                    {/* Resource Instance Id */}
                    <TextField
                        select
                        name="nResourceInstanceId"
                        label="Resource Instance Id"
                        value={formData["nResourceInstanceId"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        // SelectProps={{
                        //     MenuProps: {
                        //         PaperProps: {
                        //             style: {
                        //                 maxHeight: 200,
                        //                 width: 300,
                        //             },
                        //         },
                        //     },
                        // }}

                        SelectProps={{
                            MenuProps: {
                                PaperProps: {
                                    style: {
                                        maxHeight: 200,
                                        width: 300,
                                    },
                                },
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                },
                                getContentAnchorEl: null, // Very important in MUI v4
                            },
                        }}
                        disabled={isEdit ? true : true} // resource id change nahi hone paye so disablibng for both add and edit
                    >
                        {uniqueLoandReadinessInstanceId?.map((option) => (
                            <MenuItem key={option} value={option}
                                disabled={loanReadinessAlreadyFilledPersonaInstanceId?.includes(option)}
                            >{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Net Profit Margin */}
                    <TextField
                        name="Net Profit Margin"
                        label="Net Profit Margin"
                        value={formData["Net Profit Margin"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        type="number"
                    />

                    {/* Existing Loan */}
                    <TextField
                        name="Existing Loan - (if any Amount, Type and Bank)"
                        label="Existing Loan - (if any Amount, Type and Bank)"
                        value={formData["Existing Loan - (if any Amount, Type and Bank)"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    {/* Type of Bank Account */}
                    <TextField
                        select
                        name="Type of Bank Account"
                        label="Type of Bank Account"
                        value={formData["Type of Bank Account"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['Saving Account', 'Current Account'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Financial Reports */}
                    <TextField
                        select
                        name="Financial Reports(ITR, B/S)"
                        label="Financial Reports(ITR, B/S)"
                        value={formData["Financial Reports(ITR, B/S)"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['yes', 'no'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Business Entity Related Documents */}
                    <TextField
                        name="Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"
                        label="Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"
                        value={formData["Business Entity related documents(e.g Partnership Deed, Business PAN, MOA, AOA, Certificate of Incorporation)"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    {/* Credit Score */}
                    <TextField
                        name="Credit Score (CIBIL)"
                        label="Credit Score (CIBIL)"
                        value={formData["Credit Score (CIBIL)"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        type="number"
                        inputProps={{ min: 700, max: 900 }}
                    />

                    {/* Quotation Documents */}
                    <TextField
                        select
                        name="Quotation Documents"
                        label="Quotation Documents"
                        value={formData["Quotation Documents"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['yes', 'no'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Guarantor Details */}
                    <TextField
                        select
                        name="Guarantor details"
                        label="Guarantor details"
                        value={formData["Guarantor details"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['yes', 'no'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Collateral */}
                    <TextField
                        select
                        name="Collateral"
                        label="Collateral"
                        value={formData["Collateral"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['yes', 'no'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Receivable */}
                    <TextField
                        select
                        name="Receivable"
                        label="Receivable"
                        value={formData["Receivable"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['Cash', 'Digital Banking', 'Physical Banking', 'All of Above'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Payables */}
                    <TextField
                        select
                        name="Payables"
                        label="Payables"
                        value={formData["Payables"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['Cash', 'Digital Banking', 'Physical Banking', 'All of Above'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Loan Amount Required */}
                    <TextField
                        name="Loan Amount Required"
                        label="Loan Amount Required"
                        value={formData["Loan Amount Required"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    {/* Required Type of Loan */}
                    <TextField
                        select
                        name="Required Type of Loan(Term Loan/Cash Credit/ Composite)"
                        label="Required Type of Loan(Term Loan/Cash Credit/ Composite)"
                        value={formData["Required Type of Loan(Term Loan/Cash Credit/ Composite)"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['Term Loan', 'Cash Credit', 'Composite'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Loan Purpose */}
                    <TextField
                        name="Loan Purpose ( Mention distribution if composite)"
                        label="Loan Purpose ( Mention distribution if composite)"
                        value={formData["Loan Purpose ( Mention distribution if composite)"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    {/* Loan Application Status */}
                    <TextField
                        select
                        name="Loan Application status"
                        label="Loan Application status"
                        value={formData["Loan Application status"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['Not Applied', 'Applied', 'Approved', 'Not Approved'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Application Status Reasoning */}
                    <TextField
                        name="Application status reasoning"
                        label="Application status reasoning"
                        value={formData["Application status reasoning"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    {/* Services Availed */}
                    <TextField
                        select
                        name="Services Availed(BLRP phase I / BLRP phase II )"
                        label="Services Availed(BLRP phase I / BLRP phase II )"
                        value={formData["Services Availed(BLRP phase I / BLRP phase II )"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    >
                        {['B1 Business Loan Readiness Intervention ', 'B2 Funding Proposal Creation'].map((option) => (
                            <MenuItem key={option} value={option}>{option}</MenuItem>
                        ))}
                    </TextField>

                    {/* Key Recommendations */}
                    <TextField
                        name="Key Recommendations"
                        label="Key Recommendations"
                        value={formData["Key Recommendations"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        name="Learnings"
                        label="Learnings"
                        value={formData["Learnings"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        name="Challenges"
                        label="Challenges"
                        value={formData["Challenges"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        name="BLRP phase I / BLRP phase II report links"
                        label="BLRP phase I / BLRP phase II report links"
                        value={formData["BLRP phase I / BLRP phase II report links"]}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                    />

                    <TextField
                        name="Product Catalog Links"
                        label="Product Catalog Links"
                        value={formData["Product Catalog Links"] ? formData["Product Catalog Links"] : "N/A"}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        disabled={true}
                    />
                </Box>

                {/* Modal Footer with Action Buttons */}
                <Box style={actionsStyle}>
                    <Button variant="outlined" onClick={onClose}>
                        Cancel
                    </Button>
                    {
                        isEdit ? (
                            <Button variant="contained" style={{ backgroundColor: '#75287C', color: 'white' }} onClick={() => handleUpdateButtonClick(formData)}>
                                Update
                            </Button>
                        ) : (
                            <Button variant="contained" style={{ backgroundColor: '#75287C', color: 'white' }} onClick={() => submitBusinessLoanPersonaForm(formData)}>
                                Submit
                            </Button>
                        )
                    }
                </Box>
            </Box>
        </Modal>
    );
};

export default FormModalLoanReadiness;
